import { getTransparentIconStyles } from "components/DYStackers/styles"
import PropTypes from "prop-types"
import React from "react"

export function getSVGSrcBase64(svgXml) {
  return `data:image/svg+xml;base64,${btoa(svgXml)}`
}

const createInlineSvgHtml = (svgStr) => ({
  dangerouslySetInnerHTML: { __html: svgStr },
})
export function InlineSVGIcon({ iconSvgText, className, style }) {
  return (
    <div
      className={className === undefined ? "icon-info" : className}
      style={{
        height: 15,
        width: 15,
        ...getTransparentIconStyles(),
        ...(style || {}),
      }}
      // src={`${AEM_ASSETS}/temp/icon-info.svg`}
      {...createInlineSvgHtml(iconSvgText)}
    />
  )
}

// eslint-disable-next-line react/display-name
export const InlineRefSVGIcon = React.forwardRef(
  ({ iconSvgText, className, style }, ref) => {
    return (
      <div
        ref={ref}
        className={className === undefined ? "icon-info" : className}
        style={{
          height: 15,
          width: 15,
          ...getTransparentIconStyles(),
          ...(style || {}),
        }}
        // src={`${AEM_ASSETS}/temp/icon-info.svg`}
        {...createInlineSvgHtml(iconSvgText)}
      />
    )
  }
)

InlineSVGIcon.propTypes = {
  iconSvgText: PropTypes.string,
  className: PropTypes.string,
  //alt: PropTypes.string,
  style: PropTypes.any,
}

InlineRefSVGIcon.propTypes = {
  iconSvgText: PropTypes.string,
  className: PropTypes.string,
  //alt: PropTypes.string,
  style: PropTypes.any,
}
